import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

class Trial extends Component {
  render() {
    const { isTrial, trialComponent, regularComponent } = this.props;

    return (
      <React.Fragment>
        {isTrial ? trialComponent : regularComponent}
      </React.Fragment>
    );
  }
}

Trial.propTypes = {
  isTrial: PropTypes.bool.isRequired,
  regularComponent: PropTypes.element.isRequired,
  trialComponent: PropTypes.element
};

Trial.defaultProps = {
  regularComponent: null,
  trialComponent: null
};

const mapStateToProps = (state) => {
  return {
    isTrial: state.getIn(['currentUser', 'data', 'trialEndsAt']) === null
  };
};

export default connect(mapStateToProps)(Trial);



// WEBPACK FOOTER //
// ./app/components/shared/Trial.jsx